"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UncontrolledTooltip = _interopRequireDefault(require("reactstrap/lib/UncontrolledTooltip"));

var _utils = require("../lib/utils");

require("./tooltip.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Tooltip = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Tooltip, _React$PureComponent);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addSafariStyle", function (target) {
      var _this$props = _this.props,
          showToolTip = _this$props.showToolTip,
          overflowOnly = _this$props.overflowOnly;

      if (showToolTip && overflowOnly && (0, _utils.isSafariBrowser)()) {
        target.classList.add("oui-disable-safari-tooltip");
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showTooltip", function () {
      var _this$props2 = _this.props,
          showToolTip = _this$props2.showToolTip,
          overflowOnly = _this$props2.overflowOnly;
      var target = _this.state.target;

      if (showToolTip && target) {
        if (overflowOnly) {
          var isOverflow = target.scrollWidth > target.clientWidth;
          return isOverflow;
        }

        return true;
      }

      return false;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getMaxWidth", function () {
      var _context;

      var maxWidth = _this.props.maxWidth;
      return (0, _endsWith["default"])(_context = String(maxWidth)).call(_context, "px") ? maxWidth : "".concat(maxWidth, "px");
    });
    _this.state = {
      target: null
    };
    _this.ref = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.bindTarget();
    }
  }, {
    key: "bindTarget",
    value: function bindTarget() {
      // eslint-disable-next-line react/no-find-dom-node
      var target = _reactDom["default"].findDOMNode(this.ref.current);

      if (target instanceof HTMLElement || target instanceof SVGElement) {
        this.setState({
          target: target
        });
        this.addSafariStyle(target);
      } else {
        // eslint-disable-next-line no-console
        console.error("Could not find target for the tooltip component.");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          text = _this$props3.text,
          dataTestId = _this$props3.dataTestId,
          className = _this$props3.className,
          textAlign = _this$props3.textAlign,
          children = _this$props3.children;
      var target = this.state.target;
      var isCustom = (0, _utils.isFunction)(text);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-fragments
        _react["default"].createElement(_react["default"].Fragment, null, this.showTooltip() ? /*#__PURE__*/_react["default"].createElement(_UncontrolledTooltip["default"], (0, _extends2["default"])({
          "data-testid": dataTestId,
          trigger: "hover focus",
          boundariesElement: "window",
          innerClassName: className,
          className: (0, _utils.gatherClasses)(this.props, isCustom ? "oui-custom-tooltip" : null),
          style: isCustom ? {} : {
            textAlign: textAlign,
            maxWidth: this.getMaxWidth()
          }
        }, (0, _utils.gatherConditionalProps)(this.props, "placement", "delay"), {
          target: target
        }), isCustom ? text() : text) : null, /*#__PURE__*/_react["default"].createElement(TooltipWrapper, {
          ref: this.ref
        }, children))
      );
    }
  }]);
  return Tooltip;
}(_react["default"].PureComponent);

Tooltip.propTypes = {
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]).isRequired,
  placement: _propTypes["default"].oneOf(["auto", "top", "right", "bottom", "left"]),
  className: _propTypes["default"].string,
  showToolTip: _propTypes["default"].bool,
  overflowOnly: _propTypes["default"].bool,
  textAlign: _propTypes["default"].oneOf(["left", "center", "right"]),
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  dataTestId: _propTypes["default"].string,
  delay: _propTypes["default"].number,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].func])
};
Tooltip.defaultProps = {
  delay: 300,
  placement: "top",
  showToolTip: true,
  overflowOnly: false,
  textAlign: "left",
  maxWidth: 200,
  className: "",
  dataTestId: "orion-tooltip"
};
Tooltip.displayName = "OrionTooltip";
var _default = Tooltip;
/**
 * TooltipWrapper will help binding ref on the Tooltip children component
 * As that ref is further used to pass the target element to UncontrolledTooltip
 */

exports["default"] = _default;

var TooltipWrapper = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TooltipWrapper, _React$Component);

  var _super2 = _createSuper(TooltipWrapper);

  function TooltipWrapper() {
    (0, _classCallCheck2["default"])(this, TooltipWrapper);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(TooltipWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);
  return TooltipWrapper;
}(_react["default"].Component);

TooltipWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node, _propTypes["default"].func])
};